import { AddRounded, CloseRounded } from '@mui/icons-material';
import {
    Box,
    Card,
    CardContent,
    Chip,
    Grid,
    List,
    ListItemIcon,
    ListSubheader,
    MenuItem,
    Popover,
    Typography,
} from '@mui/material';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getContactFilterByName } from './filterSets';

// TODO: Add autocomplete for address fields

const Filters = ({
    filterSet,
    filters,
    addFilter,
    removeFilter,
    wrapFilters,
    fullWidth,
    hiddenFilters = [],
    filtersExtention,
    setFilter,
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [openedFilter, setOpenedFilter] = useState(null);
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);

    const filtersArray = Object.entries(filters).filter(
        ([key]) => !hiddenFilters.includes(key),
    );

    const isLastOddFilter = index =>
        index % 2 === 0 && index === filterSet.length - 1;

    return (
        <>
            <Box display="flex" gap={1}>
                <Box
                    display="flex"
                    gap={1}
                    {...(!fullWidth ? { overflow: 'auto' } : {})}
                    {...(wrapFilters && !fullWidth ? { flexWrap: 'wrap' } : {})}
                >
                    {filtersArray.map(([key, values], index) => {
                        // split the last part of the key to get the filterOption
                        const keyParts = key.split('__');
                        const lookup = keyParts.pop();
                        const filterField = keyParts.join('__');

                        const { Icon, ...filterObject } =
                            getContactFilterByName(filterField) || {};

                        return (
                            <Fragment key={index}>
                                {values.map((value, index) => {
                                    return (
                                        <Chip
                                            key={index}
                                            label={
                                                <>
                                                    {t(filterObject?.label)}
                                                    &nbsp;
                                                    {t(
                                                        `controls:lookuplabels.${lookup}`,
                                                    )}
                                                    &nbsp;
                                                    <b>
                                                        {filterObject?.renderLabel?.(
                                                            value,
                                                        ) || value}
                                                    </b>
                                                </>
                                            }
                                            icon={Icon && <Icon />}
                                            deleteIcon={<CloseRounded />}
                                            onDelete={() =>
                                                removeFilter(key, value)
                                            }
                                        />
                                    );
                                })}
                            </Fragment>
                        );
                    })}
                    {(wrapFilters || !filtersArray.length) && (
                        <Chip
                            label={t('Add Filter')}
                            variant="outlined"
                            onClick={e =>
                                setAnchorEl(e.currentTarget.parentElement)
                            }
                            deleteIcon={<AddRounded />}
                            onDelete={e =>
                                setAnchorEl(e.currentTarget.parentElement)
                            }
                            // variant="outlined"
                        />
                    )}
                    {filtersExtention}
                </Box>
                {!wrapFilters && Boolean(filtersArray.length) && (
                    <Chip
                        label={t('Add Filter')}
                        variant="outlined"
                        onClick={e =>
                            setAnchorEl(e.currentTarget.parentElement)
                        }
                        deleteIcon={<AddRounded />}
                        onDelete={e =>
                            setAnchorEl(e.currentTarget.parentElement)
                        }
                        // variant="outlined"
                    />
                )}
            </Box>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: theme => theme.shape.xl,
                            padding: 2,
                            width: 432,
                        },
                    },
                }}
                transitionDuration={{
                    enter: 225,
                    appear: 225,
                    exit: 0,
                }}
            >
                <Grid container>
                    {filterSet.map((column, colIndex) => (
                        <Grid
                            key={colIndex}
                            item
                            xs={isLastOddFilter(colIndex) ? 12 : 6}
                        >
                            {column.map((filterGroup, index) => (
                                <List
                                    key={index}
                                    sx={{
                                        ...(isLastOddFilter(colIndex) && {
                                            height:
                                                36 *
                                                    Math.ceil(
                                                        filterGroup.filters
                                                            .length / 2,
                                                    ) +
                                                16,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flexWrap: 'wrap',
                                        }),
                                    }}
                                    subheader={
                                        <ListSubheader>
                                            {t(filterGroup.header)}
                                        </ListSubheader>
                                    }
                                >
                                    {filterGroup.filters.map(
                                        (filterField, fieldIndex) => {
                                            const {
                                                Icon,
                                                label,
                                                name,
                                                Component,
                                            } = filterField;
                                            return (
                                                <Fragment key={fieldIndex}>
                                                    <MenuItem
                                                        key={fieldIndex}
                                                        onClick={e => {
                                                            setOpenedFilter(
                                                                name,
                                                            );
                                                            setFilterAnchorEl(
                                                                e.currentTarget,
                                                            );
                                                        }}
                                                        sx={{
                                                            borderRadius:
                                                                theme =>
                                                                    theme.shape
                                                                        .sm,
                                                        }}
                                                    >
                                                        <ListItemIcon>
                                                            <Icon />
                                                        </ListItemIcon>
                                                        {t(label)}
                                                    </MenuItem>
                                                    <Component
                                                        filterField={{
                                                            ...filterField,
                                                            label: t(label),
                                                        }}
                                                        open={
                                                            openedFilter ===
                                                            name
                                                        }
                                                        anchorEl={
                                                            filterAnchorEl
                                                        }
                                                        onClose={() =>
                                                            setOpenedFilter(
                                                                null,
                                                            )
                                                        }
                                                        addFilter={addFilter}
                                                        removeFilter={
                                                            removeFilter
                                                        }
                                                        filters={filters}
                                                        setFilter={setFilter}
                                                    />
                                                </Fragment>
                                            );
                                        },
                                    )}
                                </List>
                            ))}
                        </Grid>
                    ))}
                </Grid>
            </Popover>
        </>
    );
};

export default Filters;
